import React from 'react';
import { formatText } from 'core/i18n';
import { checkUserInvestmentTypeAndReturnActiveOne } from 'utilities/userProfile';
import { getNameCountryByCountry } from 'utilities/multiLanguageHelper';
import ConditionalToggling from 'utilities/toggling/ConditionalToggling/ConditionalToggling';
import { RadioButton } from 'components/RadioButton/RadioButton';
import { Tin } from 'components/newAccountSteps/initialStep/fields/Tin/Tin';
import { CREDIT_CARD } from 'constants/userProfile';
import { CHANNEL } from 'constants/uTagConstants/origin';

export const Resident = ({
    userProfile,
    userProfileForm,
    formActions,
    actions,
    submitButtonValidations,
    onChange,
    handleValidateResident,
    onFocusTin,
}) => {
    const userInvestmentType = checkUserInvestmentTypeAndReturnActiveOne(userProfile.investmentType);

    const createOption = (labelKey, value, additionalComponent = null) => ({
        label: formatText(labelKey),
        value,
        additionalComponent,
    });

    const optionsList = [
        createOption(
            'field-yes',
            true,
            <Tin
                userProfile={userProfile}
                userProfileForm={userProfileForm}
                formActions={formActions}
                actions={actions}
                submitButtonValidations={submitButtonValidations}
                onFocus={onFocusTin}
            />
        ),
        createOption('field-no', false),
    ];

    const handleIsUpdated = () =>
        handleValidateResident({
            isResident: userProfile.resident === 'true',
            isContactCenter: userProfile.jointHolderData?.invite?.channel === CHANNEL.CC,
        });

    const errorMessages = {
        required: formatText('validation-radioRequired'),
    };

    const radioButtonStyle = {
        margin: '0 0 -9px',
    };

    if (userProfile?.universiaName) return null;

    return (
        <ConditionalToggling condition={!userInvestmentType[CREDIT_CARD]}>
            <div className="row form__input md-form-group">
                <div className="col-sm-6">
                    <label>{formatText('passport-areResidentPassport', [formatText(getNameCountryByCountry())])}</label>
                    <RadioButton
                        profileModel="userProfile.resident"
                        optionsList={optionsList}
                        isRequired
                        isUpdated={handleIsUpdated}
                        onChange={onChange}
                        messagesError={errorMessages}
                        style={radioButtonStyle}
                        userProfile={userProfile}
                        userProfileForm={userProfileForm}
                        formActions={formActions}
                    />
                </div>
            </div>
        </ConditionalToggling>
    );
};
